import * as React from "react";
import { useCallback, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { MultiSelect } from "components/common";
import { Col, ControlLabel, FormGroup, HelpBlock, Row } from "components/bootstrap";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
import { ALL_MESSAGES_TIMERANGE } from "views/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { defaultCompare } from "logic/DefaultCompare";
import AggregationConditionsForm from "./AggregationConditionsForm";
import commonStyles from "../common/commonStyles.css";
const AggregationForm = ({ aggregationFunctions, eventDefinition, validation, onChange }) => {
  var _a, _b, _c;
  const { t } = useTranslation("event_definitions");
  const { data: allFieldTypes } = useFieldTypes((_b = (_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.streams) != null ? _b : [], ALL_MESSAGES_TIMERANGE);
  const formattedFields = useMemo(() => allFieldTypes != null ? allFieldTypes : [], [allFieldTypes]);
  const formattedFieldOptions = useMemo(
    () => formattedFields.sort((ftA, ftB) => defaultCompare(ftA.name, ftB.name)).map((fieldType) => ({
      label: `${fieldType.name} \u2013 ${fieldType.value.type.type}`,
      value: fieldType.name
    })),
    [formattedFields]
  );
  const sendTelemetry = useSendTelemetry("event-definition-condition");
  const propagateConfigChange = useCallback(
    (update) => {
      const nextConfig = { ...eventDefinition.config, ...update };
      onChange("config", nextConfig);
    },
    [eventDefinition.config, onChange]
  );
  const handleGroupByChange = useCallback(
    (selected) => {
      const nextValue = selected === "" ? [] : selected.split(",");
      sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_CONDITION.AGGREGATION_GROUP_BY_FIELD_SELECTED, {
        app_action_value: "group-by-field-select",
        selection_count: nextValue.length
      });
      propagateConfigChange({ group_by: nextValue });
    },
    [propagateConfigChange, sendTelemetry]
  );
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement("h2", { className: commonStyles.title }, t("aggregation_form.title")), /* @__PURE__ */ React.createElement("p", null, t("aggregation_form.description")), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { lg: 7 }, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "group-by" }, /* @__PURE__ */ React.createElement(ControlLabel, null, t("summary.group_by"), " ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, t("filter_form.optional"))), /* @__PURE__ */ React.createElement(
    MultiSelect,
    {
      id: "group-by",
      onChange: handleGroupByChange,
      options: formattedFieldOptions,
      ignoreAccents: false,
      value: ((_c = eventDefinition.config.group_by) != null ? _c : []).join(","),
      allowCreate: true
    }
  ), /* @__PURE__ */ React.createElement(HelpBlock, null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "aggregation_form.group_by_help", components: { bold: /* @__PURE__ */ React.createElement("b", null) } }), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "aggregation_form.group_by_example", components: { code: /* @__PURE__ */ React.createElement("code", null), em: /* @__PURE__ */ React.createElement("em", null) } }))))), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement(
    AggregationConditionsForm,
    {
      eventDefinition,
      validation,
      formattedFields,
      aggregationFunctions,
      onChange: propagateConfigChange
    }
  ));
};
export default AggregationForm;
